export default {
  "Precipitation-Rainfall": "RF",
  "Precipitation-GPM Rainfall": "precip_gpm_rainfall",
  "Soil Moisture-Root Zone Soil Moisture (0 - 50 cm)": "RSM",
  "Soil Moisture-Upper Soil Moisture (0 - 15 cm)": "USM",
  "Soil Moisture-Lower Soil Moisture (15 - 50 cm)": "LSM",
  "Soil Moisture-Deep Soil Moisture (50 - 150 cm)": "DSM",
  "Evapotranspiration-Potential Evapotranspiration": "et_potential",
  "Evapotranspiration-Actual Evapotranspiration": "ET",
  "Evapotranspiration-Reference Crop Evapotranspiration": "et_ref_crop",
  "Evapotranspiration-Evapotranspiration from Open Water Bodies":
    "et_open_water_body",
  Runoff: "RO",
  "Runoff-#": "RO",
  "Forecast Surface Runoff-1": "FSRO_1",
  "Forecast Surface Runoff-2": "FSRO_2",
  "Forecast Surface Runoff-3": "FSRO_3",
  "Standardized Precipitation Index (SPI)-1 Month": "spi_1mon",
  "Standardized Precipitation Index (SPI)-3 Month": "spi_3mon",
  "Standardized Precipitation Index (SPI)-6 Month": "spi_6mon",
  "Standardized Precipitation Index (SPI)-12 Month": "spi_12mon",
  "Standardized Runoff Index (SRI)-1 Month": "sri_1mon",
  "Standardized Runoff Index (SRI)-3 Month": "sri_3mon",
  "Standardized Runoff Index (SRI)-6 Month": "sri_6mon",
  "Standardized Runoff Index (SRI)-12 Month": "sri_12mon",
  "Basin Scale Fluxes-Rainfall": "basin_flux_rainfall",
  "Basin Scale Fluxes-Runoff": "basin_flux_runoff",
  "Basin Scale Fluxes-Evapotranspiration": "basin_flux_et",
  "Basin Scale Fluxes-Soil Moisture": "basin_flux_sm",
  "Soil Moisture Adequacy Index": "sm_adeq_Index",
  "Snow Melt Runoff": "snow_melt_runoff",
  "smai-weekly":"SMAI",
  "smai-monthly":"SMAI"
};
